export default "__VITE_ASSET__KN5z$JeW__"